<template>
  <el-row style="width: 100%;margin-top: 87px;">
    <!--  轮播图  -->
    <el-row style="height: 660px;">
      <el-carousel :interval="4000" trigger="click" arrow="always" height="660px">
        <el-carousel-item v-for="(item, i) in imgList" :key="i">
          <el-row :style="{backgroundImage: 'url(' + item + ')', width: '100%', height: '100%', backgroundSize:'100% 100%', backgroundRepeat:'no-repeat'}">
          </el-row>
        </el-carousel-item>
      </el-carousel>
    </el-row>
    <slot>
    </slot>
  </el-row>
</template>

<script>
export default {
  name: 'ProdPage',
  props: ['id', 'selId'],
  data() {
    return {
      imgList: [require('../../assets/product.jpg')]
    }
  },
  methods: {}
}
</script>

<style scoped>
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/ProdPage.vue